import { FieldBlock, Input, useToast } from '@orbind/ui'
import { useMutation } from '@tanstack/react-query'
import { useState } from 'react'
import { useNavigate } from 'react-router'
import { FormRow, FormScreen, FormSection } from '../../components/FormScreen.tsx'
import { api } from '../../lib/api.ts'
import { adotarSessao, useWorkspaces } from './WorkspaceMenu.tsx'

/**
 * Criar um workspace ADICIONAL (usuario ja logado), no padrao FormScreen —
 * substitui o antigo modal. O primeiro workspace de quem entra sem nenhum
 * continua na tela dedicada /setup-workspace (fluxo do onboarding).
 *
 * Criar reemite o token no servidor e a sessao ja troca para o workspace novo
 * (adotarSessao recarrega o app inteiro — todo cache pertence ao anterior).
 */

export function NovoWorkspacePage() {
  const toast = useToast()
  const navigate = useNavigate()
  const { data: workspaces } = useWorkspaces()
  const [nome, setNome] = useState('')

  const criar = useMutation({
    mutationFn: async (name: string) => {
      const resposta = await api.workspaces.$post({ json: { name } })
      const dados = (await resposta.json()) as {
        token?: string
        workspace?: { name: string }
        error?: { message?: string }
      }
      if (!resposta.ok || !dados.token) throw new Error(dados.error?.message ?? 'Não foi possível criar.')
      return dados as { token: string; workspace: { name: string } }
    },
    onSuccess: (dados) => {
      toast.push({ tone: 'success', message: `${dados.workspace.name} criado — você já está nele.` })
      void adotarSessao(dados.token)
    },
    onError: (erro) =>
      toast.push({ tone: 'danger', message: erro instanceof Error ? erro.message : 'Não foi possível criar.' }),
  })

  const podeCriar = nome.trim().length >= 2 && !criar.isPending

  return (
    <FormScreen
      title="Criar workspace"
      onClose={() => navigate(-1)}
      dirty={nome.trim().length >= 2}
      dirtyHint="Preencha o nome para criar"
      saveLabel="Criar e entrar"
      saveDisabled={!podeCriar}
      saving={criar.isPending}
      onSubmit={() => podeCriar && criar.mutate(nome.trim())}
    >
      <FormSection title="Novo workspace" collapsible={false}>
        <p className="adm-hint">
          Um workspace é um espaço de trabalho completo e separado: portfólio, demandas, Itens de Trabalho, quadros e
          cadastros próprios. Você vira o dono, entra nele assim que criar e pode voltar aos outros pelo menu do nome
          do workspace{workspaces && workspaces.length > 0 ? ` (você participa de ${workspaces.length}).` : '.'}
        </p>
        <FormRow cols="minmax(220px, 520px)">
          <FieldBlock label="Nome" required hint="Nome da empresa ou do time — dá para mudar depois em Editar workspace.">
            {({ id }) => (
              <Input
                id={id}
                autoFocus
                placeholder="Ex.: Wynk, Time de Produto"
                value={nome}
                onChange={(e) => setNome(e.target.value)}
              />
            )}
          </FieldBlock>
        </FormRow>
      </FormSection>
    </FormScreen>
  )
}
